import { useQuery } from '@tanstack/react-query';

import { api } from '@shared/api/client';
import { key, STALE_TIME } from '@shared/api/query-keys';

/**
 * Reads the shell needs on every route.
 *
 * The unread figure is the top bar's, not the inbox's: the indicator announces
 * state continuously, so it is read wherever the shell is drawn. `/inbox`
 * invalidates the same key after a bulk mark or delete, which is what keeps the
 * badge and the table moving together.
 *
 * `unread_count` is snake_case on the wire because `backend-notification`
 * serialises its payloads without the camelCase alias generator the other seven
 * services apply. The console follows the callee, not the convention.
 */
interface UnreadCountPayload {
  unread_count: number;
}

export function unreadCountKey() {
  return key('notification', 'unreadCount');
}

export function useUnreadCount() {
  return useQuery({
    queryKey: unreadCountKey(),
    queryFn: () => api.get<UnreadCountPayload>('notification', '/notifications/unreadCount'),
    staleTime: STALE_TIME.list,
    // The badge is an ornament on every route but `/inbox`. A failed read leaves
    // it absent rather than turning a chrome slot into an error surface.
    throwOnError: false,
  });
}
